// extracted by mini-css-extract-plugin
module.exports = {"clickable":"TopBottomTable_clickable__UreYF"};